export const getRandomColor = (index: number): string => {
    const colors = [
        '#4299E1', // blue-500
        '#48BB78', // green-500
        '#ED8936', // orange-500
        '#9F7AEA', // purple-500
        '#F56565', // red-500
        '#ECC94B', // yellow-500
        '#38B2AC', // teal-500
        '#ED64A6', // pink-500
        '#667EEA', // indigo-500
        '#4FD1C5', // teal-400
    ];

    return colors[index % colors.length];
};

export const calculateVisualizationDimensions = (
    width: number,
    height: number,
    scale: number = 4,
    maxWidth: number = 1200,
    maxHeight: number = 800
) => {
    return {
        width: Math.min(width * scale, maxWidth),
        height: Math.min(height * scale, maxHeight),
    };
};